import CodeBlock from '@/ui-kit/components/CodeBlock';
import { ParameterDisplayMode } from '@tarslib/types/lib/projectSetting';
import clsx from 'clsx';
import styles from './RequestSampleCodeCode.module.css';

export type RequestSampleCodeCodeProps = {
  code: string | undefined;
  language: string | undefined;
  mode?: ParameterDisplayMode;
  className?: string;
};

export function RequestSampleCodeCode(props: RequestSampleCodeCodeProps) {
  const { code, language, className, mode = ParameterDisplayMode.CLASSIC } = props;

  if (!code) {
    return null;
  }
  return (
    <CodeBlock
      code={code}
      language={language}
      className={clsx(
        'bg-code-viewer',
        styles['code-viewer'],
        {
          ['pt-0']: mode === ParameterDisplayMode.CLASSIC,
          [`${styles['code-viewer-modern']}`]: mode === ParameterDisplayMode.MODERN,
          ['max-h-[500px] flex-1 @[850px]/http-api-content:h-0 @[850px]/http-api-content:max-h-[unset]']:
            mode === ParameterDisplayMode.MODERN,
        },
        className,
      )}
      highlightTheme="github-dark"
      onlyCode={false}
    />
  );
}
